import { wordCategories, getAllCategories } from './words';

const getWordsForDifficulty = (categoryWords, difficulty) => {
  let words = [];

  // Always include easy words
  if (categoryWords.easy) {
    words = words.concat(categoryWords.easy);
  }

  // Include medium words if difficulty is medium or hard
  if ((difficulty === 'medium' || difficulty === 'hard') && categoryWords.medium) {
    words = words.concat(categoryWords.medium);
  }

  // Include hard words only if difficulty is hard
  if (difficulty === 'hard' && categoryWords.hard) {
    words = words.concat(categoryWords.hard);
  }

  return words;
};

const getWordsForDifficulties = (categoryWords, difficulties) => {
  let words = [];

  // Handle array of difficulties or single difficulty
  const difficultyArray = Array.isArray(difficulties) ? difficulties : [difficulties];

  // If no difficulties selected, default to medium (with cumulative behavior)
  if (difficultyArray.length === 0) {
    return getWordsForDifficulty(categoryWords, 'medium');
  }

  // If only one difficulty, use cumulative behavior
  if (difficultyArray.length === 1) {
    return getWordsForDifficulty(categoryWords, difficultyArray[0]);
  }

  // Multiple difficulties selected - collect words from specific levels only
  difficultyArray.forEach(difficulty => {
    if (categoryWords[difficulty]) {
      words = words.concat(categoryWords[difficulty]);
    }
  });

  return words;
};

export const getRandomWord = (categories = ['all'], difficulties = 'medium') => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let availableWords = [];

      // Handle array of categories or single category for backward compatibility
      const categoryArray = Array.isArray(categories) ? categories : [categories];

      // If no categories selected or includes 'all', use all categories
      if (categoryArray.length === 0 || categoryArray.includes('all')) {
        const allCategories = getAllCategories();
        allCategories.forEach(cat => {
          if (wordCategories[cat]) {
            const categoryWords = getWordsForDifficulties(wordCategories[cat], difficulties);
            availableWords = availableWords.concat(categoryWords);
          }
        });
      } else {
        // Use only selected categories
        categoryArray.forEach(category => {
          if (wordCategories[category]) {
            const categoryWords = getWordsForDifficulties(wordCategories[category], difficulties);
            availableWords = availableWords.concat(categoryWords);
          }
        });
      }

      if (availableWords.length === 0) {
        resolve('No words available');
        return;
      }

      const randomIndex = Math.floor(Math.random() * availableWords.length);
      resolve(availableWords[randomIndex]);
    }, 100);
  });
};

export const getCategories = () => {
  return [
    { value: 'all', label: 'All Categories' },
    { value: 'animals', label: 'Animals' },
    { value: 'objects', label: 'Objects' },
    { value: 'actions', label: 'Actions' },
    { value: 'food', label: 'Food' },
    { value: 'places', label: 'Places' },
    { value: 'vehicles', label: 'Vehicles' },
    { value: 'books', label: 'Books' },
    { value: 'sports', label: 'Sports' },
    { value: 'history', label: 'History' }
  ];
};

export const getDifficultyOptions = () => {
  return [
    { value: 'easy', label: 'Easy' },
    { value: 'medium', label: 'Medium' },
    { value: 'hard', label: 'Hard' }
  ];
};